import React, {useRef, useLayoutEffect} from "react"
import {LoaderClass} from "./LoaderClass"
import {FaFolder, FaFolderOpen} from "react-icons/fa"
import {removeCookieOfFolderId} from "../functions"
import {useNavigate} from "react-router-dom"

export default function CloudinaryUploadCard({data, lang}) {

    const {
        tree,
        rootFolderId,
        selectedFolder,
        uploading,
        progress,
        result,
        error,
        files,
        fileNames,
        setFileNames,
        handleToggle,
        handleFileChange,
        handleUpload,
        handleDrag,
        handleDrop,
        dragActive,
        currentIndex
    } = data

    const containerRef = useRef(null)
    const navigate = useNavigate()

    useLayoutEffect(() => {
        const id = selectedFolder?.id
        if (!id) return

        const container = containerRef.current
        const node = document.getElementById(`folder-${id}`)
        if (!container || !node) return

        const nodeTop = node.offsetTop
        const nodeBottom = nodeTop + node.offsetHeight

        const viewTop = container.scrollTop
        const viewBottom = viewTop + container.clientHeight

        if (nodeTop < viewTop) {
            container.scrollTo({top: nodeTop - 20, behavior: "smooth"})
        } else if (nodeBottom > viewBottom) {
            container.scrollTo({
                top: nodeBottom - container.clientHeight + 20,
                behavior: "smooth"
            })
        }

    }, [tree, selectedFolder.id])

    const TreeNode = ({id, level = 0}) => {
        const node = tree[id]
        if (!node) return null

        return (
            <div>
                <div
                    id={`folder-${id}`}
                    className={`folder-class`}
                    onClick={() => handleToggle(node)}
                    style={{
                        paddingLeft: level * 16,
                        cursor: "pointer",
                        background: selectedFolder.id === node.id ? "#d4f4dd" : "transparent",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <div style={{width: 20, height: 20, marginRight: 6}}>
                        {node.loading ? (
                            <LoaderClass positon={'relative'} top={0} left={0} marginTop={1} width={1} height={1}/>
                        ) : (
                            <span>
                                {node.expanded ?
                                    <FaFolderOpen size={18} color={"orange"} /> :
                                    <FaFolder size={18} color="orange" />}
                            </span>
                        )}
                    </div>
                    <span>{node.name}</span>
                </div>

                {node.expanded &&
                node.children.map(childId => (
                    <TreeNode key={childId} id={childId} level={level + 1}/>
                ))}
            </div>
        )
    }

    if (result) {
        removeCookieOfFolderId(selectedFolder.id)
        setTimeout(() => {
            navigate(`/${lang.lang}/folder/open/${selectedFolder.id}`, {replace: true})
        }, 2000)
    }

    return (
        <div
            style={{
                maxWidth: 600,
                margin: "20px auto",
                padding: 20,
                border: dragActive ? "2px dashed #4caf50" : "2px dashed transparent",
                background: dragActive ? "#f0fff4" : "transparent",
                transition: "all 0.2s ease"
            }}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}>

            <div
                ref={containerRef}
                style={{border: "1px solid #ddd", padding: 10, maxHeight: 300, overflow: "auto"}}>
                <TreeNode id={rootFolderId}/>
            </div>

            <div style={{ display: 'flex', marginTop: 10 }}>
                <p>Грузим сюда:</p>
                <h5 style={{ marginLeft: 10 }}>
                    {tree[selectedFolder.id]?.name || selectedFolder.name}
                </h5>
            </div>

            {!uploading && !result && (
                <>
                    <label className="upload-btn">
                        {'Выбрать изображения'}
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            hidden
                            accept="image/*"
                        />
                    </label>

                    {files.length > 0 && (
                        <div className={'upload-files-list'}>
                            {files.map((f, i) => (
                                <div className="upload-file-row">
                                    <input
                                        className="upload-file-name-input"
                                        key={i}
                                        value={fileNames[i]}
                                        onChange={e => {
                                            const arr = [...fileNames]
                                            arr[i] = e.target.value
                                            setFileNames(arr)
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}

            {uploading && (
                <div style={{marginTop: 10, marginBottom: 10}}>
                    {`Загружается файл (${currentIndex + 1} из ${files.length})`}
                    <br />
                    <strong>{files[currentIndex].name}</strong>
                </div>
            )}

            {result && (
                <div style={{marginTop: 10, marginBottom: 10}}>
                    Загружено файлов: {result.count}
                </div>
            )}

            {!uploading && !result && (
                <button
                    onClick={handleUpload}
                    disabled={!files || !files.length}
                    className="upload-button"
                    style={{opacity: !files || !files.length ? 0 : 1}}
                >
                    {'Загрузить'}
                </button>
            )}

            {(uploading || result) && (
                <div style={{
                    marginTop: 10,
                    width: "100%",
                    height: 24,
                    background: "#e0e0e0",
                    borderRadius: 6,
                    overflow: "hidden",
                    position: "relative"
                }}>
                    <div
                        style={{
                            width: `${progress}%`,
                            height: "100%",
                            background: "#2196f3",
                            transition: "width 0.2s ease"
                        }}
                    />

                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        fontWeight: "bold",
                        color: "#fff",
                        pointerEvents: "none"
                    }}>
                        {progress}%
                    </div>
                </div>
            )}

            {error && <div style={{color: "red", marginTop: 10}}>{error}</div>}
            {result && <div style={{color: "green", marginTop: 10}}>Файлы успешно загружены</div>}
        </div>
    )
}
